import React from 'react';
import styled from 'styled-components';
import { Body, StandardCard, Theme } from '@routific/hive';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const StyledStandardCard = styled(StandardCard)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DeleteContainer = styled.div`
  display: flex;
  align-items: center;
`;

interface Props {
  style?: React.CSSProperties;
}

const DeletingCard: React.FC<Props> = ({ style }) => (
  <StyledStandardCard level="info" style={style} stateless>
    <DeleteContainer>
      <Spin indicator={<LoadingOutlined style={{ fontSize: 18, color: Theme.Colors.textSecondary }} spin />} />
      <Body style={{ marginLeft: Theme.Spacing.smSpacing }} type="secondary">
        Deleting
      </Body>
    </DeleteContainer>
  </StyledStandardCard>
);

export default DeletingCard;
